import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { StudentVM } from "@shared-kernel/application/ports/student/student-repository";

export const retrieveStudentProfile = createAsyncThunk<StudentVM, void, { extra: Partial<Dependencies> }>(
  "students/retrieveStudentProfile",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.profile();
  },
);
